(function () {
  "use strict";

  a3_cabin_reports.controller("PaxCtrl", PaxCtrl);

  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name PaxCtrl
   * @description
   *  Manages the passenger seatmap and information view
   * @ngInject
   */
  function PaxCtrl(
    $scope,
    FlightFactory,
    PaxInfoFactory,
    FlightOrdersFactory,
    CampaignFactory,
    CabinReportLocalEditFactory,
    LuggageComplianceFactory,
    UserFactory,
    $route,
    $routeParams,
    $uibModal,
    $location,
    SettingsMain,
    MisconnectionFlightsFactory,
    defaultCalendarDate
  ) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    var report =
      CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
    $scope.state = "pax";
    $scope.flight = flight;
    $scope.showMobileMenuFilters = false;
    $scope.filterPax = filterPax;
    $scope.viewMode = viewMode;
    $scope.filterRow = filterRow;
    $scope.filterCol = filterCol;
    $scope.howClose = "";
    $scope.IsOld = IsOld;
    $scope.openPassenger = openPassenger;
    $scope.resetFilters = resetFilters;
    $scope.isConnectedFlightClose = isConnectedFlightClose;
    $scope.TimeDifference = TimeDifference;
    $scope.getTierCount = getTierCount;
    $scope.applyLuggageCompliance = applyLuggageCompliance;
    $scope.IsProvisional = true;
    $scope.specialMeals = 0;
    $scope.multiSelectCount = 0;
    $scope.luggageComplianceConfirmation = luggageComplianceConfirmation;
    $scope.close = close;
    $scope.toggleFlightInfoView = toggleFlightInfoView;
    $scope.mode = "seatMap";
    $scope.radioModel = "Seatmap";

    $scope.flightCompliant =
      LuggageComplianceFactory.getFlightCompliantStatus(flightId);

    $scope.IsShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();

    $scope.searchText = { passengerName: "" };

    var user = UserFactory.getUser();
    $scope.isUserSA = user.position == "SA" ? true : false;

    if (flight == null) {
      flight = FlightFactory.getLocalFlightFromStorage(flightId);
    }

    // $scope.saEligibility = flight.LineStatus && flight.LineStatus != 'na';
    if (flight && flight.LineStatus && flight.LineStatus !== "na") {
      $scope.saEligibility = true;
    } else {
      $scope.saEligibility = false;
    }

    PaxInfoFactory.setMaskPaxInfoInRoute(flight);

    var paxInfo = null;
    PaxInfoFactory.getPaxInfoFromStorage(flightId, function (result) {
      paxInfo = result;
      $scope.paxInfo = paxInfo;

      var flightOrders =
        FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);

      if (paxInfo && report) {
        //Set upgraded seats and changed seats from report to paxinfo
        setUpgradedSeatsFromReport(report.UpgradedPassengers);
        if (report.ChangedSeats) {
          setChangedSeatsFromReport(report.ChangedSeats);
          //Get ChangedSeats Counter
          $scope.paxInfo.changedSeatsNo = report.ChangedSeats.length;
        } else {
          $scope.paxInfo.changedSeatsNo = 0;
        }
      }

      if (flight != null) {
        if (paxInfo) {
          var connectingPax = 0;
          for (var i = 0; i < paxInfo.ConnectingFlights.length; i++) {
            connectingPax =
              connectingPax +
              paxInfo.ConnectingFlights[i].PassengerSummaryC.Passengers +
              paxInfo.ConnectingFlights[i].PassengerSummaryY.Passengers;
          }
          $scope.connectingPax = connectingPax;

          for (var i = 0; i < paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
              if (paxInfo.Seatmap[i].Columns[j].SpecialMeal) {
                $scope.specialMeals++;
              }

              if (paxInfo.Seatmap[i].Columns[j].SpecialMealB) {
                $scope.specialMeals++;
              }

              if (
                paxInfo.Seatmap[i].Columns[j].ConnectingFlightId &&
                paxInfo.Seatmap[i].Columns[j].ConnectingFlightId != 0
              ) {
                for (var h = 0; h < paxInfo.ConnectingFlights.length; h++) {
                  if (
                    paxInfo.Seatmap[i].Columns[j].ConnectingFlightId ==
                    paxInfo.ConnectingFlights[h].FlightId
                  ) {
                    paxInfo.Seatmap[i].Columns[j].Connection =
                      paxInfo.ConnectingFlights[h];
                  }
                }
              }

              //if(report && flight.showPaxNames){
              if (
                flight.showPaxNames &&
                $scope.IsShopInTheCloudEnable &&
                paxInfo.Seatmap[i].Columns[j].Fullname != null
              ) {
                // Split Fullname into Firstname and Lastname
                const [lastname, firstname] =
                  paxInfo.Seatmap[i].Columns[j].Fullname.split(" ");
                //get flag for the flight orders - shop in the cloud
                var foundOrders = null;
                if (flightOrders) {
                  foundOrders = flightOrders.Orders.filter(
                    (order) =>
                      order.Passenger.FirstName === firstname &&
                      order.Passenger.LastName === lastname &&
                      order.Passenger.PNR === paxInfo.Seatmap[i].Columns[j].PNR
                  );
                }

                if (foundOrders && foundOrders.length > 0) {
                  $scope.paxInfo.Seatmap[i].Columns[j].HasFlightOrder = true;
                  $scope.paxInfo.Seatmap[i].Columns[j].FlightOrders =
                    foundOrders;
                  var orderStatusIsPending = false;
                  foundOrders.forEach(function (order) {
                    if (!order.Status) {
                      orderStatusIsPending = true;
                    }
                  });
                  $scope.paxInfo.Seatmap[i].Columns[
                    j
                  ].FlightOrderStatusIsPending = orderStatusIsPending;
                } else {
                  $scope.paxInfo.Seatmap[i].Columns[j].HasFlightOrder = false;
                }
              }
            }
          }
          if ($scope.IsShopInTheCloudEnable) {
            //Update passenger orders counter
            updateFlightOrdersCounters();
          }

          attachMisconnectionStatusToPax();

          var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
          var DepartureTimestamp = new Date(
            flight.ScheduledDeparture
          ).getTime();
          //20 minutes before takeoff
          if (DepartureTimestamp - listSentTimestamp <= 1200000) {
            $scope.IsProvisional = false;
          }
        }

        var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
        $scope.flightETA = flight.ETA
          ? new Date(flight.ETA).getTime()
          : flightArrivalTime;

        attachCampaign($scope.paxInfo);
        attachLuggageCompliance();

        initializeFilters();
        initializeViewMode();
      } else {
        $location.path("/");
      }
    });

    /**
     * Set upgraded seats from report to paxinfo
     * @memberof PaxCtrl
     */
    function setUpgradedSeatsFromReport(upgradedPassengers) {
      for (var k = 0; k < upgradedPassengers.length; k++) {
        for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
            if (
              $scope.paxInfo.Seatmap[i].Columns[j].UCI ==
                upgradedPassengers[k].UCI &&
              $scope.paxInfo.Seatmap[i].Columns[j].PNR ==
                upgradedPassengers[k].PNR
            ) {
              $scope.paxInfo.Seatmap[i].Columns[j].UpgradedToSeat =
                upgradedPassengers[k];
            }
          }
        }
      }
    }
    /**
     * Set changed seats from report to paxinfo
     * @memberof PaxCtrl
     */
    function setChangedSeatsFromReport(changedSeats) {
      for (var k = 0; k < changedSeats.length; k++) {
        for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
            if (
              $scope.paxInfo.Seatmap[i].Columns[j].UCI == changedSeats[k].UCI &&
              $scope.paxInfo.Seatmap[i].Columns[j].PNR == changedSeats[k].PNR
            ) {
              $scope.paxInfo.Seatmap[i].Columns[j].ChangedSeat =
                changedSeats[k];
            }
          }
        }
      }
    }

    /**
     * Toggle view from seatmap to paxlist
     * @memberof PaxCtrl
     */
    function toggleFlightInfoView(mode) {
      $scope.mode = mode;
    }

    /**
     * Initialize Passenger Filters
     * @memberof PaxCtrl
     */
    function initializeFilters() {
      $scope.filterPaxC = false;
      $scope.filterPaxY = false;
      $scope.filterAdults = false;
      $scope.filterChildren = false;
      $scope.filterInfants = false;
      $scope.filterUMs = false;
      $scope.filterFqtv = false;
      $scope.filterConnections = false;
      $scope.filterSpecialMeals = false;
      $scope.filterFqtvPlatinum = false;
      $scope.filterFqtvSilver = false;
      $scope.filterFqtvGold = false;
      $scope.filterWheelchair = false;
      $scope.filterAssistance = false;
      $scope.filterDeportees = false;
      $scope.filterVIP = false;
      $scope.filterFlightOrders = false;
      $scope.filterDHC = false;
      $scope.filterChargeableSeats = false;
      $scope.filterEligibleForUpgrade = false;
      $scope.filterSeatChanges = false;
      $scope.filterIrregularities = false;
      $scope.filterCampaigns = false;
      $scope.multiSelect = false;
      // $scope.searchText = { passengerName: ''};
    }

    /**
     * Filter Passenger by given filter
     * @memberof PaxCtrl
     * @param {string} criteria The selected filter criteria
     */
    function filterPax(criteria) {
      if (criteria == "PaxC") {
        var val = !$scope.filterPaxC;
        initializeFilters();
        $scope.filterPaxC = val;
      } else if (criteria == "PaxY") {
        var val = !$scope.filterPaxY;
        initializeFilters();
        $scope.filterPaxY = val;
      } else if (criteria == "Adults") {
        var val = !$scope.filterAdults;
        initializeFilters();
        $scope.filterAdults = val;
      } else if (criteria == "Children") {
        var val = !$scope.filterChildren;
        initializeFilters();
        $scope.filterChildren = val;
      } else if (criteria == "Infants") {
        var val = !$scope.filterInfants;
        initializeFilters();
        $scope.filterInfants = val;
      } else if (criteria == "Fqtv-platinum") {
        var val = !$scope.filterFqtvPlatinum;
        initializeFilters();
        $scope.filterFqtvPlatinum = val;
      } else if (criteria == "Fqtv-silver") {
        var val = !$scope.filterFqtvSilver;
        initializeFilters();
        $scope.filterFqtvSilver = val;
      } else if (criteria == "Fqtv-gold") {
        var val = !$scope.filterFqtvGold;
        initializeFilters();
        $scope.filterFqtvGold = val;
      } else if (criteria == "Connections") {
        var val = !$scope.filterConnections;
        $scope.showConnections = true;
        initializeFilters();
        $scope.filterConnections = val;
      } else if (criteria == "UMs") {
        var val = !$scope.filterUMs;
        initializeFilters();
        $scope.filterUMs = val;
      } else if (criteria == "SpecialMeals") {
        var val = !$scope.filterSpecialMeals;
        initializeFilters();
        $scope.showMeals = true;
        $scope.filterSpecialMeals = val;
      } else if (criteria == "Wheelchair") {
        var val = !$scope.filterWheelchair;
        initializeFilters();
        $scope.filterWheelchair = val;
      } else if (criteria == "Assistance") {
        var val = !$scope.filterAssistance;
        initializeFilters();
        $scope.filterAssistance = val;
      } else if (criteria == "Deportees") {
        var val = !$scope.filterDeportees;
        initializeFilters();
        $scope.filterDeportees = val;
      } else if (criteria == "VIP") {
        var val = !$scope.filterVIP;
        initializeFilters();
        $scope.filterVIP = val;
      } else if (criteria == "FlightOrders") {
        var val = !$scope.filterFlightOrders;
        initializeFilters();
        $scope.filterFlightOrders = val;
      } else if (criteria == "DHC") {
        var val = !$scope.filterDHC;
        initializeFilters();
        $scope.filterDHC = val;
      } else if (criteria == "ChargeableSeats") {
        var val = !$scope.filterChargeableSeats;
        initializeFilters();
        $scope.filterChargeableSeats = val;
      } else if (criteria == "UPGD") {
        var val = !$scope.filterEligibleForUpgrade;
        initializeFilters();
        $scope.filterEligibleForUpgrade = val;
      } else if (criteria == "SeatChange") {
        var val = !$scope.filterSeatChanges;
        initializeFilters();
        $scope.filterSeatChanges = val;
      } else if (criteria == "Irregularities") {
        var val = !$scope.filterIrregularities;
        initializeFilters();
        $scope.filterIrregularities = val;
      } else if (criteria == "Campaigns") {
        var val = !$scope.filterCampaigns;
        initializeFilters();
        $scope.filterCampaigns = val;
      } else if (criteria == "MultiSelect") {
        var val = !$scope.multiSelect;
        //initializeFilters();
        initialiazeMultiSelectCounter();
        $scope.multiSelect = val;
      } else if (criteria == "searchText") {
        var val = $scope.searchText.passengerName;
        initializeFilters();
      }
    }

    function initialiazeMultiSelectCounter() {
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          column.isMultiSelected = false;
        });
      });

      $scope.multiSelectCount = 0;
    }

    function luggageComplianceConfirmation() {
      if ($scope.multiSelectCount > 0) {
        $scope.modalInstance = $uibModal.open({
          templateUrl: "dlgLuggageComplianceConfirmation.html",
          scope: $scope,
        });
      }
    }

    function close() {
      $scope.modalInstance.close();
    }

    function applyLuggageCompliance() {
      var columns = [];
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          columns.push(column);
        });
      });

      var selectedPassengers = columns.filter((c) => c.isMultiSelected);

      selectedPassengers.forEach(function (passenger, index) {
        var cabinLuggageReport = {
          PNR: passenger.PNR,
          UCI: passenger.UCI,
          FlightId: flightId,
          FareFamily: passenger.FareFamily,
          IsFlightCompliant: false,
          Created: moment(),
        };
        passenger.opcc = true; //attachLuggageCompliance
        LuggageComplianceFactory.saveLuggageComplianceToStorage(
          cabinLuggageReport,
          index
        );
      });

      $scope.modalInstance.close();
      filterPax("MultiSelect");
    }

    /**
     * Initialize View Mode
     * @memberof PaxCtrl
     */
    function initializeViewMode() {
      $scope.showPaxName = true;
      $scope.showDetails = true;
      $scope.showConnections = true;
      $scope.showMeals = false;
    }

    /**
     * Set the desired view style
     * @memberof PaxCtrl
     * @param {string} mode The view mode
     */
    function viewMode(mode) {
      if (mode == "PaxName") {
        $scope.showPaxName = !$scope.showPaxName;
      } else if (mode == "Details") {
        $scope.showDetails = !$scope.showDetails;
      } else if (mode == "Connections") {
        $scope.showConnections = !$scope.showConnections;
      } else if (mode == "Meals") {
        $scope.showMeals = !$scope.showMeals;
      }
    }

    /**
     * Show only the  Rows that have a passenger that is valid with the current filters
     * @memberof PaxCtrl
     * @param {object} row The passenger row
     */
    function filterRow(row) {
      var isValid = false;
      if (
        $scope.filterPaxC ||
        $scope.filterPaxY ||
        $scope.filterAdults ||
        $scope.filterChildren ||
        $scope.filterInfants ||
        $scope.filterUMs ||
        $scope.filterFqtv ||
        $scope.filterConnections ||
        $scope.filterSpecialMeals ||
        $scope.filterFqtvPlatinum ||
        $scope.filterFqtvSilver ||
        $scope.filterFqtvGold ||
        $scope.filterWheelchair ||
        $scope.filterWheelchair ||
        $scope.filterAssistance ||
        $scope.filterDeportees ||
        $scope.filterDHC ||
        $scope.filterVIP ||
        $scope.filterFlightOrders ||
        $scope.filterChargeableSeats ||
        $scope.filterEligibleForUpgrade ||
        $scope.filterSeatChanges ||
        $scope.filterIrregularities ||
        $scope.filterCampaigns ||
        $scope.multiSelect ||
        $scope.searchText.passengerName.length > 1
      ) {
        for (var i = 0; i < row.Columns.length; i++) {
          if (filterCol(row.Columns[i])) {
            isValid = true;
          }
        }
      } else {
        isValid = true;
      }
      return isValid;
    }

    /**
     * Disable the  passenger seats that is not valid with the current filters
     * @memberof PaxCtrl
     * @param {object} col The passenger seat
     */
    function filterCol(col) {
      var IsValid = true;

      if ($scope.filterPaxC && col.Cabin != "C") {
        IsValid = false;
      } else if ($scope.filterPaxY && col.Cabin != "Y") {
        IsValid = false;
      } else if ($scope.filterAdults && col.Type != "A") {
        IsValid = false;
      } else if ($scope.filterChildren && col.Type != "C") {
        IsValid = false;
      } else if (
        $scope.filterInfants &&
        col.Type != "I" &&
        !(col.Type == "A" && col.InfantName)
      ) {
        IsValid = false;
      } else if ($scope.filterFqtv && col.Fqtv == null) {
        IsValid = false;
      } else if ($scope.filterConnections && col.Connection == null) {
        IsValid = false;
      } else if ($scope.filterUMs && !(col.SSR != null && col.SSR.IsUMNR)) {
        IsValid = false;
      } else if (
        $scope.filterSpecialMeals &&
        col.SpecialMeal == null &&
        col.SpecialMealB == null
      ) {
        IsValid = false;
      } else if (
        $scope.filterFqtvPlatinum &&
        !(col.Fqtv != null && col.Fqtv.TierLevel == "PLTM")
      ) {
        IsValid = false;
      } else if (
        $scope.filterFqtvSilver &&
        !(
          col.Fqtv != null &&
          (col.Fqtv.TierLevel == "BLUT" || col.Fqtv.TierLevel == "SLVT")
        )
      ) {
        IsValid = false;
      } else if (
        $scope.filterFqtvGold &&
        !(col.Fqtv != null && col.Fqtv.TierLevel == "GLDT")
      ) {
        IsValid = false;
      } else if (
        $scope.filterWheelchair &&
        !(col.SSR != null && col.SSR.IsGroupPRM)
      ) {
        IsValid = false;
      } else if (
        $scope.filterAssistance &&
        !(
          col.SSR != null &&
          (col.SSR.IsDEAF || col.SSR.IsBLND || col.SSR.IsDPNA)
        )
      ) {
        IsValid = false;
      } else if (
        $scope.filterDeportees &&
        !(col.SSR != null && (col.SSR.IsINAD || col.SSR.IsGroupDEP))
      ) {
        IsValid = false;
      } else if ($scope.filterVIP && !col.IsVIP) {
        IsValid = false;
      } else if ($scope.filterFlightOrders && !col.HasFlightOrder) {
        IsValid = false;
      } else if ($scope.filterDHC && !col.IsDHC) {
        IsValid = false;
      } else if ($scope.filterChargeableSeats && !(col.IsCHU || col.IsCHX)) {
        IsValid = false;
      } else if ($scope.filterEligibleForUpgrade && !col.IsEligibleForUpgrade) {
        IsValid = false;
      } else if ($scope.filterSeatChanges && !col.ChangedSeat) {
        IsValid = false;
      } else if (
        $scope.filterIrregularities &&
        !col.UndeliveredChargeableSeat
      ) {
        IsValid = false;
      } else if ($scope.filterCampaigns && !col.Campaign) {
        IsValid = false;
      } else if (
        $scope.multiSelect &&
        (col.IsEmptySeat || col.SeatMode != "Seat")
      ) {
        IsValid = false;
      } else if (
        $scope.searchText.passengerName.length > 1 &&
        (col.Fullname == null ||
          !col.Fullname.toLowerCase().includes(
            $scope.searchText.passengerName.toLowerCase()
          ))
      ) {
        IsValid = false;
      }

      return IsValid;
    }

    /**
     * Initialize Passenger Filters and the desired view style
     * @memberof PaxCtrl
     */
    function resetFilters() {
      initializeFilters();
      initializeViewMode();
    }

    /**
     * Gets Platinum counters without depending on backend-only summary fields.
     * Uses summary values when available and falls back to the seat map.
     * @memberof PaxCtrl
     * @param {string} tierName The tier name to count
     * @returns {number} total passengers for the tier
     */
    function getTierCount(tierName) {
      if (!$scope.paxInfo || tierName != "Platinum") {
        return 0;
      }

      var summaryC =
        $scope.paxInfo.PassengerSummaryC &&
        $scope.paxInfo.PassengerSummaryC.FQTVPlatinum;
      var summaryY =
        $scope.paxInfo.PassengerSummaryY &&
        $scope.paxInfo.PassengerSummaryY.FQTVPlatinum;

      if (
        typeof summaryC === "number" &&
        typeof summaryY === "number"
      ) {
        return summaryC + summaryY;
      }

      if (!$scope.paxInfo.Seatmap) {
        return 0;
      }

      var total = 0;
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (column) {
          if (
            !column.IsEmptySeat &&
            column.Fqtv &&
            column.Fqtv.TierLevel == "PLTM"
          ) {
            total++;
          }
        });
      });

      return total;
    }

    /**
     * Open Passenger Modal View
     * @memberof PaxCtrl
     * @param {object} inputObject The passenger information
     */
    function openPassenger(inputObject) {
      if (
        $scope.multiSelect &&
        !inputObject.IsEmptySeat &&
        (inputObject.SeatMode == "Seat" || inputObject.SeatMode == "Jumpseat")
      ) {
        inputObject.isMultiSelected = !inputObject.isMultiSelected;

        var columns = [];
        $scope.paxInfo.Seatmap.forEach(function (row) {
          row.Columns.forEach(function (column) {
            columns.push(column);
          });
        });

        $scope.multiSelectCount = columns.filter(
          (c) => c.isMultiSelected
        ).length;
      } else if (
        inputObject.IsEmptySeat == 0 &&
        (inputObject.SeatMode == "Seat" || inputObject.SeatMode == "Jumpseat")
      ) {
        // kzan::: Remove
        attachDummyConnection(inputObject);

        var modalInstance = $uibModal.open({
          templateUrl: "views/Dialogs/dlgPassenger.html",
          controller: "PassengerCtrl",
          size: "lg",
          backdrop: "static",
          keyboard: false,
          scope: $scope,
          resolve: {
            passenger: function () {
              return inputObject;
            },
            flightId: function () {
              return flightId;
            },
            paxInfo: function () {
              return paxInfo;
            },
            report: function () {
              return report;
            },
          },
        });
        modalInstance.result.then(
          function () {
            //passenger upgraded, reload pax
            $route.reload();
          },
          function () {
            //$route.reload();
            attachCampaign();
            updateCampaignsCounters();
            attachLuggageCompliance();
          }
        );
      }
    }

    function attachDummyConnection(pax) {
      if (!pax) {
        return;
      }

      // Only override if there is no existing connection
      if (pax.Connection) {
        return;
      }

      // pax.Connection = {
      //     FlightNo: 'A3 940',
      //     Departure: 'ATH',
      //     Arrival: 'RUH',
      //     // Local time (what you show as "STD_Local" in the UI)
      //     STD_Local: new Date('2025-11-21T09:00:00'),
      //     // UTC time (or scheduled base time)
      //     STD: new Date('2025-11-21T07:00:00Z'),
      //     DepartureGate: 'A12',
      //     // Used by IsOld() in the template to show the gate warning
      //     UpdatedDate: new Date('2025-11-21T08:00:00Z')
      // };
    }

    /**
     * Checks if the data are new
     * @memberof PaxCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */
    function IsOld(time) {
      IsOld = false;
      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();
        if (diff > 3600000) {
          IsOld = true;
        }
      }
      return IsOld;
    }

    /**
     * Calculates if a connecting flight is departs sort time after fligths arrival
     * @memberof PaxCtrl
     * @param {string} connection Connection STD
     * @return {string} cssClass
     */
    function isConnectedFlightClose(connection) {
      //disable bg colors for connections after customer request : 25-01-2026 (Re: Bug Report: Connections Panel & Pax Connection Info)
      return "";
      if (!connection) {
        return "";
      }

      var connFlightDate = new Date(connection.STD).getTime();

      if ($scope.flightETA > connFlightDate) return "";


      if (connFlightDate - $scope.flightETA < connection.MCT * 60000) {
        return "bg-bisque";
      }

      if (connFlightDate - $scope.flightETA < (connection.MCT + 15) * 60000) {
        return "bg-cornsilk";
      }
      return "";
    }

    /**
     * Returns the time difference
     * @memberof PaxCtrl
     * @param {string} time Connection STD
     * @return {string} timeDifference
     */
    function TimeDifference(time) {
      var timeString = "";
      var sign = "";
      var dayString = null;

      if (time) {
        var connFlightDate = new Date(time);
        var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
        if (ms < 0) {
          ms = -ms;
          sign = "-";
        }

        var days = Math.floor(ms / (24 * 60 * 60 * 1000));
        days = days < 0 ? days + 1 : days;
        var daysms = ms % (24 * 60 * 60 * 1000);
        var hours = Math.floor(daysms / (60 * 60 * 1000));
        var hoursms = ms % (60 * 60 * 1000);
        var minutes = Math.floor(hoursms / (60 * 1000));
        timeString =
          "<strong>" +
          sign +
          (hours > 0 ? ("0" + hours).substr(-2) + ":" : "") +
          ("0" + minutes).substr(-2) +
          "'" +
          "<strong>";
        dayString = ' <span class="badge mb-1half">' + days + "d</span>";
      }
      return timeString + (days && days != 0 ? dayString : "");
    }

    function attachCampaign() {
      if ($scope.paxInfo) {
        $scope.paxInfo.CampaignCounters = {
          pending: 0,
          completed: 0,
        };

        $scope.paxInfo.Seatmap.forEach(function (s) {
          s.Columns.forEach(function (col) {
            if (col.UCI) {
              var campaignInfo = CampaignFactory.getPaxAssignment(
                +flightId,
                col.PNR,
                col.UCI
              );
              if (campaignInfo.assignment) {
                col.Campaign = JSON.parse(JSON.stringify(campaignInfo));

                if (col.Campaign.assignment.Status == 0)
                  $scope.paxInfo.CampaignCounters.pending += 1;

                if (col.Campaign.assignment.Status != 0)
                  $scope.paxInfo.CampaignCounters.completed += 1;
              }
            }
          });
        });
      }
    }

    function attachLuggageCompliance() {
      if ($scope.paxInfo) {
        $scope.paxInfo.Seatmap.forEach(function (s) {
          s.Columns.forEach(function (col) {
            if (col.UCI) {
              var opccReport =
                LuggageComplianceFactory.getPassengerLuggageCompliance(
                  flightId,
                  col.UCI
                );
              col.opcc = opccReport != null;
            }
          });
        });
      }
    }

    function updateCampaignsCounters() {
      $scope.paxInfo.CampaignCounters = {
        pending: 0,
        completed: 0,
      };

      $scope.paxInfo.Seatmap.forEach(function (s) {
        s.Columns.forEach(function (col) {
          if (col.Campaign) {
            if (col.Campaign.assignment.Status == 0) {
              $scope.paxInfo.CampaignCounters.pending += 1;
            }

            if (col.Campaign.assignment.Status != 0) {
              $scope.paxInfo.CampaignCounters.completed += 1;
            }
          }
        });
      });
    }

    function updateFlightOrdersCounters() {
      var counters = {
        pendingOrders: 0,
        allOrders: 0,
      };
      //TODO: uncomment on live - create a temp report to active the orders
      //if(report && flight.showPaxNames){
      if (report && flight.showPaxNames) {
        var passengerList = [];
        if ($scope.paxInfo) {
          for (var i = 0; i < $scope.paxInfo.Seatmap.length; i++) {
            for (var j = 0; j < $scope.paxInfo.Seatmap[i].Columns.length; j++) {
              var passenger = $scope.paxInfo.Seatmap[i].Columns[j];
              if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
                passengerList.push(passenger);
              }
            }
          }
        }
        counters = passengerList.reduce(
          (acc, { HasFlightOrder, FlightOrderStatusIsPending }) => {
            if (HasFlightOrder) {
              acc.allOrders++;
              if (FlightOrderStatusIsPending) {
                acc.pendingOrders++;
              }
            }
            return acc;
          },
          {
            pendingOrders: 0,
            allOrders: 0,
          }
        );
      }
      $scope.paxInfo.flightOrdersCounters = counters;

      console.log($scope.paxInfo.flightOrdersCounters);
    }

    function attachMisconnectionStatusToPax() {
      if (!$scope.paxInfo || !$scope.paxInfo.Seatmap || !flightId) {
        return;
      }
      var misconnectionStatusByUci = {};
      var misconnectionFlights = [];

      if (defaultCalendarDate && flightId === "1226541") {
        misconnectionFlights =
          MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(
            2242084 //<=(747 17-6-2016)
          ) || [];
      } else {
        // 1) Get misconnection flights for this disrupted flight from local storage
        misconnectionFlights =
          MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(
            flightId
          ) || [];
      }

      if (!misconnectionFlights.length) {
        return;
      }

      // 2) For each passenger in the seatmap, check if they have a misconnection flight
      misconnectionFlights.forEach(function (misconnectionFlight) {
        if (
          !misconnectionFlight.Passengers ||
          !misconnectionFlight.Passengers.length
        ) {
          return;
        }

        misconnectionFlight.Passengers.forEach(function (pax) {
          if (!pax.UCI) {
            return;
          }

          var actions = pax.Actions || [];
          if (!actions.length) {
            return;
          }

          var currentStatus = misconnectionStatusByUci[pax.UCI] || {
            hasEscort: false,
            hasReprotection: false,
            lastUpdatedAction: null,
            showReprotection: false,
            reprotectionEvents: [],
          };

          var statusFromActions = calculateStatusFromActions(actions);
          // Debug log per UCI (optional)
          console.log("[MC][UCI]", pax.UCI, {
            actions: actions,
            status: statusFromActions,
          });

          // Merge (OR) with existing status in case the same UCI appears in more than one route group
          currentStatus.hasEscort =
            currentStatus.hasEscort || statusFromActions.hasEscort;

          currentStatus.hasReprotection =
            currentStatus.hasReprotection || statusFromActions.hasReprotection;

          // Keep the latest reprotection decision timestamp
          if (statusFromActions.lastUpdatedAction) {
            if (
              !currentStatus.lastUpdatedAction ||
              statusFromActions.lastUpdatedAction >
                currentStatus.lastUpdatedAction
            ) {
              currentStatus.lastUpdatedAction =
                statusFromActions.lastUpdatedAction;
            }
          }




          // Final red flag for Pax List coloring
          currentStatus.showReprotection = currentStatus.hasReprotection;

          misconnectionStatusByUci[pax.UCI] = currentStatus;
        });
      });

      // 3) Apply the computed status back to the seatmap passengers
      $scope.paxInfo.Seatmap.forEach(function (row) {
        row.Columns.forEach(function (col) {
          if (!col || col.IsEmptySeat || !col.UCI) {
            return;
          }

          var status = misconnectionStatusByUci[col.UCI];

          if (!status) {
            // Ensure previous flags do not leak into current coloring rules
            col.HasEscort = false;
            col.HasReprotection = false;
            col.LastUpdatedAction = null;
            col.ShowReprotection = false;
            col.MisconnectionDebug = null;
            return;
          }

          // Coloring rules for Pax List:
          // - Red    = ShowReprotection = true
          // - Yellow = HasEscort = true AND ShowReprotection = false
          // - White  = both false
          col.HasEscort = !!status.hasEscort;
          col.HasReprotection = !!status.hasReprotection; // keep for backward compatibility
          col.ShowReprotection = !!status.showReprotection;

          // Extra info for analysis / debugging on UI
          col.LastUpdatedAction = status.lastUpdatedAction || null;

          col.MisconnectionDebug = {
            hasEscort: status.hasEscort,
            hasReprotection: status.hasReprotection,
            showReprotection: status.showReprotection,
            lastUpdatedAction: status.lastUpdatedAction,
            reprotectionEvents: status.reprotectionEvents,
          };
        });
      });
    }

    /**
     * Returns escort/reprotection status based on actions,
     * strictly following the rule:
     *  - RED    = reprotection decided >= 60 minutes before STD
     *  - WHITE  = reprotection decided < 60 minutes before STD ("old reprotection")
     *  - YELLOW = escort
     * Additionally:
     *  - lastUpdatedAction: latest valid reprotection decision timestamp
     *  - showReprotection: final flag used by Pax List coloring
     */
    function calculateStatusFromActions(actions) {
      var result = {
        hasEscort: false,
        hasReprotection: false,
        lastUpdatedAction: null,
        showReprotection: false,
        // debug info
        reprotectionEvents: [],
      };

      if (!actions || !actions.length) {
        return result;
      }

      for (var i = 0; i < actions.length; i++) {
        var action = actions[i];

        // ESCORT: always counts (no time restriction)
        if (action.HasEscortAction) {
          result.hasEscort = true;
        }

        // REPROTECTION: only counts if decided >= 60 minutes before STD
        if (
          action.HasReprotectedAction &&
          action.STD &&
          action.ActionTimestamp
        ) {
          var std = new Date(flight.ScheduledDeparture);
          var ts = new Date(action.ActionTimestamp);

          if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
            // Invalid dates → ignore this action and continue
            continue;
          }

          var diffMinutes = (std.getTime() - ts.getTime()) / 60000;

          // debug: store every reprotection decision
          result.reprotectionEvents.push({
            std: std,
            actionTimestamp: ts,
            diffMinutes: diffMinutes,
            isCountedAsNew: diffMinutes >= 60,
          });

          // keep the latest reprotection decision (for debugging / UI)
          if (!result.lastUpdatedAction || ts > result.lastUpdatedAction) {
            result.lastUpdatedAction = ts;
          }

          // RED only if reprotection is "new" (<= 60')
          if (diffMinutes <= 60) {
            result.hasReprotection = true;
          }
          // If > 60, we ignore it (remains WHITE)
        }
      }

      // Final flag that the Pax List will use for red color
      result.showReprotection = result.hasReprotection;

      return result;
    }
  }
})();
